"use strict";

import { deleteCookie, getOptionsFromCookie, putOptionsIntoForm, validateUserOpts } from './settings.js';
import { getEl, toggleLoading, invalidateFields, resetErrors } from './dom.js';
import { toggleModal } from './modal.js';
import { setupPalette } from './palette.js';
import { setupRecommendations } from './recommendations.js';
import { loadScene } from './sketch.js';

let sceneFile;

window.onload = function () {

  function reloadChart(initialLoad) {

    if (initialLoad) {
      getEl('resultWrap').style.display = 'none';
    }

    resetErrors();
    getEl('rec').className = 'fadeOut';

    const musipie = getEl('musipie');
    musipie.className = 'fadeOut';

    while (musipie.firstChild) {
      musipie.removeChild(musipie.firstChild);
    }

    sceneFile = getEl('scene').value;

    toggleLoading(true);

    myp5 = loadScene(sceneFile);
  }

  // Only on pages with a form
  if (getEl('submit') == null) {
    return;
  }

  // Setup palette modal
  setupPalette();
  setupRecommendations();

  // Setup modal buttons    
  document.querySelectorAll('a[data-target],button[data-target]').forEach(item => {
    item.addEventListener('click',
      (event) => {
        toggleModal(event);
      })
  });

  // Get options from cookie
  let userOpts = getOptionsFromCookie();
  let autostart = false;

  if (userOpts) {
    let errors = validateUserOpts(userOpts);
    invalidateFields(errors);

    if (Object.keys(errors).length == 0) {
      autostart = true;
      putOptionsIntoForm(userOpts);
    }
  }


  let myp5;
  window.focus();

  navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
    if (result.state == 'granted' || result.state == 'prompt') {
      getEl('buttonClipboard').style.display = 'block';

    }
  });

  getEl('submit').addEventListener(
    'click',
    function () {
      reloadChart(true);
    },
    false
  );

  getEl('buttonDownload').addEventListener(
    'click', (e) => { myp5.then(m => m.downloadImage(e.target)); }, false
  );

  getEl('logoutLink').addEventListener(
    'click', () => {
      deleteCookie();
      getEl('currentUser').style.display = 'none';
      getEl('resultWrap').style.display = 'none';
      getEl('usernameForm').style.display = 'block';
    },
    false
  );

  getEl('buttonClipboard').addEventListener(
    'click', (e) => { myp5.then(m => m.copyImage(e.target)); },
    false
  );

  // Watch for form changes
  document.querySelectorAll('.changeListener').forEach(item => {
    item.addEventListener('change',
      (e) => {

        if (typeof myp5 === 'undefined') {
          return;
        }

        if (e.target.id == 'period' || e.target.name == 'data' || e.target.id == 'intFont') {
          reloadChart(false);
        } else {
          myp5.then(m => m.updateConfig());
        }
      }, false)
  });

  window.addEventListener(
    'blur',
    () => {
      setTimeout(() => {
        if (document.activeElement.tagName === 'IFRAME') {
          umami.track(document.activeElement.id + ' embed'); // eslint-disable-line no-undef
        }
      });
    },
    { once: true }
  );

  if (autostart) {
    reloadChart(true);
  }
};